import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import type { Locale } from 'date-fns';
import { getDateFnsLocale } from '@/lib/utils';

/**
 * Hook that returns the date-fns locale for the current i18next language.
 * Returns undefined while loading or if locale is not available.
 */
export function useDateFnsLocale(): Locale | undefined {
  const { i18n } = useTranslation();
  const [locale, setLocale] = useState<Locale | undefined>(undefined);
  
  useEffect(() => {
    let mounted = true;
    
    getDateFnsLocale(i18n.language).then((loadedLocale) => {
      if (mounted) {
        setLocale(loadedLocale);
      }
    });
    
    return () => {
      mounted = false;
    };
  }, [i18n.language]);
  
  return locale;
}
